import React from "react";
import { useLoader } from "../../context";
import { Backdrop, CircularProgress } from "@mui/material";

const LoaderUI = () => {
  const { isLoader } = useLoader();
  return (
    <React.Fragment>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.tooltip + 1 })}
        open={isLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default LoaderUI;
